<div class="statistics-report">
  <article class="statistics-report__sheet">

    <header class="statistics-report__head">
      <div>
        <h1>{{ 'statistics.report.title' | transloco: {year: response.year} }}</h1>
        <p>{{ shelterLabel }} · {{ 'statistics.page.period' | transloco }} {{ periodLabel }}</p>
      </div>
    </header>

    <h2 class="statistics-report__section">{{ 'statistics.report.sectionBalance' | transloco }}</h2>
    <table class="statistics-report__table">
      <thead>
      <tr class="statistics-report__group-row">
        <th></th>
        <th colspan="4">{{ 'statistics.table.groupBalance' | transloco }}</th>
        <th [attr.colspan]="columns.length">{{ 'statistics.table.groupLocation' | transloco }}</th>
        <th colspan="2">{{ 'statistics.table.groupStockAge' | transloco }}</th>
      </tr>
      <tr>
        <th>{{ 'statistics.table.category' | transloco }}</th>
        <th class="statistics-report__num">{{ startLabel }}{{ response.year }}</th>
        <th class="statistics-report__num">{{ 'statistics.table.admissions' | transloco }}</th>
        <th class="statistics-report__num">{{ 'statistics.table.departures' | transloco }}</th>
        <th class="statistics-report__num">{{ endLabel }}{{ response.year }}</th>
        @for (column of columns; track column.location) {
          <th class="statistics-report__num">{{ column.label }}</th>
        }
        <th class="statistics-report__num">{{ 'statistics.table.fromPreviousYears' | transloco }}</th>
        <th class="statistics-report__num">
          {{ 'statistics.table.fromCurrentYear' | transloco: {year: response.year} }}
        </th>
      </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.key) {
          <tr [class.statistics-report__total-row]="row.isTotal">
            <td>{{ row.label }}</td>
            <td class="statistics-report__num">{{ row.figures.stockAtPeriodStart | statCount }}</td>
            <td class="statistics-report__num">{{ row.figures.admissions | statCount }}</td>
            <td class="statistics-report__num">{{ row.figures.departures | statCount }}</td>
            <td class="statistics-report__num statistics-report__num--strong">
              {{ row.figures.stockAtPeriodEnd | statCount }}
            </td>
            @for (count of row.locationCounts; track $index) {
              <td class="statistics-report__num">{{ count | statCount }}</td>
            }
            <td class="statistics-report__num">{{ row.figures.stockBreakdown.fromPreviousYears | statCount }}</td>
            <td class="statistics-report__num">{{ row.figures.stockBreakdown.fromCurrentYear | statCount }}</td>
          </tr>
        }
      </tbody>
    </table>

    <div class="statistics-report__matrices">
      <section>
        <h2 class="statistics-report__section">{{ 'statistics.report.sectionOrigin' | transloco }}</h2>
        <ng-container
          [ngTemplateOutlet]="matrix"
          [ngTemplateOutletContext]="{
            rows: originRows,
            header: ('statistics.report.originType' | transloco)
          }">
        </ng-container>
      </section>

      <section>
        <h2 class="statistics-report__section">{{ 'statistics.report.sectionWhereabouts' | transloco }}</h2>
        <ng-container
          [ngTemplateOutlet]="matrix"
          [ngTemplateOutletContext]="{
            rows: whereaboutRows,
            header: ('statistics.report.whereaboutType' | transloco)
          }">
        </ng-container>
      </section>
    </div>

    <footer class="statistics-report__footer">
      <p>{{ footnote }}</p>
      <p>
        {{ 'statistics.report.createdAt' | transloco: {date: createdAt} }}
        {{ 'statistics.report.method' | transloco }}
      </p>
    </footer>
  </article>
</div>

<ng-template #matrix let-rows="rows" let-header="header">
  <table class="statistics-report__table statistics-report__table--matrix">
    <thead>
    <tr>
      <th>{{ header }}</th>
      @for (label of categoryLabels; track label) {
        <th class="statistics-report__num">{{ label }}</th>
      }
      <th class="statistics-report__num statistics-report__num--strong">
        {{ 'statistics.report.total' | transloco }}
      </th>
    </tr>
    </thead>
    <tbody>
      @for (row of rows; track row.label) {
        @if (row.isGroup) {
          <tr class="statistics-report__group-label">
            <td [attr.colspan]="categoryLabels.length + 2">{{ row.label }}</td>
          </tr>
        } @else {
          <tr [class.statistics-report__total-row]="row.isSum">
            <td>{{ row.label }}</td>
            @for (count of row.counts; track $index) {
              <td class="statistics-report__num">{{ count | statCount }}</td>
            }
            <td class="statistics-report__num statistics-report__num--strong">{{ row.total | statCount }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
</ng-template>
